import React from "react";
import "./Template_3.css";

const Template_3_HeroSection = () => {
  const experiences = [
    {
      image:
        "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1470&q=80",
      title: "Alpine Retreats",
      description: "Exclusive mountain escapes with panoramic vistas",
    },
    {
      image:
        "https://images.unsplash.com/photo-1506929562872-bb1555037040?auto=format&fit=crop&w=1470&q=80",
      title: "Island Paradises",
      description: "Private atolls with turquoise lagoons",
    },
    {
      image:
        "https://images.unsplash.com/photo-1530789253388-582c481c54b0?auto=format&fit=crop&w=1470&q=80",
      title: "Aurora Expeditions",
      description: "Witness celestial wonders in polar regions",
    },
    {
      image:
        "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?auto=format&fit=crop&w=1470&q=80",
      title: "Urban Elegance",
      description: "Sophisticated city experiences in world capitals",
    },
    {
      image:
        "https://images.unsplash.com/photo-1440778303588-435521a205f0?auto=format&fit=crop&w=1470&q=80",
      title: "Forest Sanctuaries",
      description: "Immersive nature retreats in ancient woodlands",
    },
    {
      image:
        "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?auto=format&fit=crop&w=1470&q=80",
      title: "Desert Oases",
      description: "Luxury camps under infinite starry skies",
    },
    {
      image:
        "https://images.unsplash.com/photo-1519046904884-5318030c56b2?auto=format&fit=crop&w=1470&q=80",
      title: "Archipelagos",
      description: "Yacht explorations of hidden island chains",
    },
  ];

  return (
    <div className="Template_3 experience-showcase">
      <div className="Template_3 header">
        <h1>Curate Your Signature Journey</h1>
        <p>
          Indulge in bespoke experiences tailored to your discerning preferences
        </p>
      </div>

      <div className="Template_3 experience-grid">
        {experiences.map((item, index) => (
          <div
            key={index}
            className={`Template_3 experience-card card-${index + 1}`}
          >
            <div className="Template_3 image-container">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="Template_3 card-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <a href="#" className="Template_3 discover-btn">
                Discover
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Template_3_HeroSection;
